import styleInject from 'style-inject';
import { collectStyles } from '@lsg/ssr';

var reactStyles = "label.lsgs-b1d71--label,.lsgs-b1d71--label{display:block;cursor:pointer;}label.lsgs-b1d71--label__inline,.lsgs-b1d71--label__inline{display:inline-block;}.lsgs-b1d71--label-input{opacity:0;height:0;width:0;position:absolute;}.lsgs-b1d71--label__overlay::after{content:\"\";position:absolute;top:0;right:0;bottom:0;left:0;}.lsgs-b1d71--label__loading{position:relative;}.lsgs-b1d71--label__loading .lsgs-b1d71--label-inner{visibility:hidden;}.lsgs-b1d71--label__disabled{pointer-events:none;cursor:default;}.lsgs-b1d71--label-spinner{display:flex;align-items:center;justify-content:center;position:absolute;top:0;left:0;right:0;bottom:0;z-index:10;}";
var mainClass = "lsgs-b1d71--label";
styleInject(reactStyles);
collectStyles(reactStyles);

export { mainClass, reactStyles };
